import React, { useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';

/** Zona reutilizable de subida: arrastrar y soltar o clic para seleccionar. */
export default function DropZone({ onFiles, accept = 'image/*', uploading = false, compact = false }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);

  const handle = (list) => {
    const arr = Array.from(list || []);
    if (arr.length) onFiles(arr);
  };

  return (
    <div
      onClick={() => !uploading && inputRef.current?.click()}
      onDragOver={(e) => { if (e.dataTransfer.types.includes('fileids') || e.dataTransfer.types.includes('folderid')) return; e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { if (e.dataTransfer.types.includes('fileids') || e.dataTransfer.types.includes('folderid')) return; e.preventDefault(); setOver(false); if (!uploading) handle(e.dataTransfer.files); }}
      className={`flex flex-col items-center justify-center gap-1.5 border-2 border-dashed rounded-lg cursor-pointer transition-colors select-none ${compact ? 'py-4' : 'py-8'} ${over ? 'border-amber-400 bg-amber-50' : 'border-stone-300 bg-stone-50 hover:border-amber-300 hover:bg-amber-50/50'} ${uploading ? 'opacity-60 cursor-wait' : ''}`}
      data-testid="dropzone"
    >
      <UploadCloud className={`${compact ? 'w-5 h-5' : 'w-7 h-7'} ${over ? 'text-amber-500' : 'text-stone-400'}`} />
      <p className="text-sm font-bold text-stone-600">
        {uploading ? 'Subiendo…' : 'Arrastra y suelta aquí, o haz clic para seleccionar'}
      </p>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={accept}
        className="hidden"
        disabled={uploading}
        onChange={(e) => { handle(e.target.files); e.target.value = ''; }}
        data-testid="dropzone-input"
      />
    </div>
  );
}
